
import {
  FETCH_TAX_REQUEST,
  FETCH_TAX_SUCCESS,
  FETCH_TAX_FAILURE,
  CREATE_TAX_REQUEST,
  CREATE_TAX_SUCCESS,
  CREATE_TAX_FAILURE,
  UPDATE_TAX_REQUEST,
  UPDATE_TAX_SUCCESS,
  UPDATE_TAX_FAILURE,
} from "./taxsettingActionType";

export const fetchTaxRequest = () => ({
  type: FETCH_TAX_REQUEST,
});

export const fetchTaxSuccess = (data, dataType) => ({
  type: FETCH_TAX_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchTaxFailure = (error) => ({
  type: FETCH_TAX_FAILURE,
  payload: error,
});

export const createTaxRequest = () => ({
  type: CREATE_TAX_REQUEST,
});

export const createTaxSuccess = (data, dataType) => ({
  type: CREATE_TAX_SUCCESS,
  payload: { data, type: dataType },
});

export const createTaxFailure = (error) => ({
  type: CREATE_TAX_FAILURE,
  payload: error,
});

export const updateTaxRequest = () => ({
  type: UPDATE_TAX_REQUEST,
});

export const updateTaxSuccess = (data, dataType) => ({
  type: UPDATE_TAX_SUCCESS,
  payload: { data, type: dataType },
});

export const updateTaxFailure = (error) => ({
  type: UPDATE_TAX_FAILURE,
  payload: error,
});
